import styled from "styled-components";
export const AppBox = styled.div`
   overflow: hidden;
`;